export const EPayPaymentStatus = {
  "0": "UNKNOWN",
  "1": "REDIRECT_CLIENT",
  "2": "PRE_PAID",
  "3": "PAID",
  "4": "VOID",
  "5": "REFUND",
  "6": "REJECT",
  "7": "ERROR",
  "8": "ROLLBACK",
  "-1": "ALL"
};

export const EPayVcardStatus = {
  "0": "UNKNOWN",
  "1": "NEW",
  "2": "CREATED",
  "3": "USED",
  "4": "CANCELED",
  "5": "CLOSED",
  "6": "ERROR",
  "-1": "ALL"
};

export const EPayVcardTrxStatus = {
  "0": "UNKNOWN",
  "1": "NEW",
  "2": "SUCCESS",
  "3": "ERROR",
  "-1": "ALL"
};

export const EPayVcardTrxType = {
  "0": "UNKNOWN",
  "1": "CREATE",
  "2": "UPDATE",
  "3": "USAGE",
  "4": "USAGE_ERROR",
  "5": "REFUND",
  "6": "INIT",
  "7": "CLOSED",
  "8": "SETTLE",
  "9": "VOID",
  "10": "VARIANCE",
  "-1": "ALL"
};

export const EPayPaymentType = {
  "0": "UNKNOWN",
  "1": "CARI",
  "2": "CREDITCARD",
  "3": "CREDITCARD_NON_3D",
  "4": "SOFORT",
  "5": "IDEAL",
  "-1": "ALL"
};

export const EPayTransactionType = {
  "0": "UNKNOWN",
  "1": "TAKE",
  "2": "CHECK_3D_RESPONSE",
  "3": "FINALIZE",
  "4": "REVERSE",
  "5": "INQUIRY",
  "-1": "ALL"
};

export const EPayVposImplementationType = {
  "0": "UNKNOWN",
  "1": "GETNET",
  "2": "SOFORT",
  "3": "IDEAL",
  "4": "ENETT",
  "5": "STRIPE",
  "-1": "ALL"
};

export const EPayCardType = {
  "0": "UNKNOWN",
  "1": "CREDIT_CARD",
  "2": "DEBIT_CARD",
  "3": "VIRTUAL_CREDIT_CARD",
  "4": "VIRTUAL_DEBIT_CARD",
  "-1": "ALL"
};

export const EPayCardBrand = {
  "0": "UNKNOWN",
  "1": "VISA",
  "2": "MASTERCARD",
  "3": "AMERICAN_EXPRESS",
  "4": "DINERS_CLUB",
  "5": "DISCOVER",
  "6": "JCB",
  "7": "CHINA_UNION_PAY",
  "-1": "ALL"
};

export const EPayCardOwner = {
  "0": "UNKNOWN",
  "1": "CUSTOMER",
  "2": "CORPORATE",
  "3": "AFFILIATE",
  "4": "VIRTUAL",
  "-1": "ALL"
};

export const EPayPaymentFinalizeType = {
  "0": "UNKNOWN",
  "1": "COMMIT",
  "2": "ROLLBACK",
  "-1": "ALL"
};